import styled from 'styled-components'
import {SubmitButton} from '@modifi/ui'

export const StyledSubmitButton = styled(SubmitButton)`
  margin: 10px 0;
  white-space: nowrap;
`
